// extracted by mini-css-extract-plugin
export default {"product":"Product_product__0V0MS","image":"Product_image__62tPO","addButton":"Product_addButton__PxatE"};